type ErrorStateProps = {
  message: string
  onRetry?: () => void
}

export default function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="error-state">
      <svg className="error-state-icon" viewBox="0 0 48 48" fill="none" aria-hidden>
        <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="1.5" />
        <path d="M24 16v10M24 30v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <p className="error-state-msg">{message}</p>
      {onRetry && (
        <button className="error-state-retry" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  )
}
